import './_product-customizer.scss';

export default () => {};
